import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Documento } from '../models/documento';
import { Galeria } from '../models/galeria';
import { Herramienta } from '../models/herramienta';
import { Infografia } from '../models/infografia';
import { Publicacion } from '../models/publicacion';
import { User } from '../models/user';
import { ParameterConst } from '../util/constant';
import { Ubigeo } from './constant/ubigeo';


@Injectable({
  providedIn: 'root'
})
export class DataService {

  private apiData = new BehaviorSubject<any>(null);
  public apiData$ = this.apiData.asObservable();

  setData(data) { 
    this.apiData.next(data)
  }

  private apiDataBill = new BehaviorSubject<any>(null);
  public apiDataBill$ = this.apiDataBill.asObservable();

  setDataBill(data) { 
    this.apiDataBill.next(data)
  }

  private apiEdit = new BehaviorSubject<Publicacion>(null);
  public apiEdit$ = this.apiEdit.asObservable();

  setEdit(data) { 
    this.apiEdit.next(data)
  }


  private apiEditHer = new BehaviorSubject<Herramienta>(null);
  public apiEditHert$ = this.apiEditHer.asObservable();

  setEditHer(data) { 
    this.apiEditHer.next(data)
  }

  private apiEditGal = new BehaviorSubject<Galeria>(null);
  public apiEditGal$ = this.apiEditGal.asObservable();

  setEditGal(data) { 
    this.apiEditGal.next(data)
  }

  private apiEditDoc = new BehaviorSubject<Documento>(null);
  public apiEditDoc$ = this.apiEditDoc.asObservable();

  setEditDoc(data) { 
    this.apiEditDoc.next(data)
  }

  private apiEditUsu = new BehaviorSubject<User>(null);
  public apiEditUsu$ = this.apiEditUsu.asObservable();

  setEditUsu(data) { 
    this.apiEditUsu.next(data)
  }

  private apiEditInfo = new BehaviorSubject<Infografia>(null);
  public apiEditInfo$ = this.apiEditInfo.asObservable();

  setEditInfo(data) { 
    this.apiEditInfo.next(data)
  }


  private url_list_situaciones = environment.apiEndpoint + "api/obtenerSituaciones.php";
  private url_list_tematicas = environment.apiEndpoint + "api/obtenerTematicas.php";
  private url_list_tematicas_perfiles = environment.apiEndpoint + "api/obtenerTematicasPerfiles.php";

  constructor(private _http:HttpClient){}
  
  obtenerSituaciones(): Observable<any>{

    const formData = new FormData();

    var sessionStr = JSON.parse(localStorage.getItem(ParameterConst.USER_LOGIN));

    formData.append("perfil", sessionStr['perfil']);

    return this._http.post(this.url_list_situaciones,formData).pipe(share());

  }


  obtenerTematicas(): Observable<any>{

    const formData = new FormData();
    return this._http.post(this.url_list_tematicas,formData).pipe(share());

  }


  obtenerTematicasPerfil(id:string): Observable<any>{

    const formData = new FormData();
    formData.append("sqUsuario", id);
    return this._http.post(this.url_list_tematicas_perfiles,formData).pipe(share());

  }


  private departamentoData = Ubigeo.departamento;

  getDepartamentos() {
    return this.departamentoData;
  }

  getProvincia(idDepartamento: string) {
    return Ubigeo.provincia[idDepartamento]
  }

  getDistritos(idProvincia: string) {
    return Ubigeo.distritos[idProvincia];
  }

  getNameDepartamento(idDepartamento:string){
    return this.departamentoData.find(x => {
      if(x.id_ubigeo == idDepartamento){
        return x; 
      } 
    })
  }

  getNameProvincia(idDepartamento:string, idProvincia:string){

    return Ubigeo.provincia[idDepartamento].find(x => {
      if(x.id_ubigeo == idProvincia){
        return x;
      }
    });

  }

  getNameDistrito(idProvincia: string, idDistrito:string){
    return Ubigeo.distritos[idProvincia].find(x => {
      if(x.id_ubigeo == idDistrito){
        return x;
      }
    });
  }
  

  static onlyNumber(event: KeyboardEvent, allowNumbers: boolean) {
  const inputChar = event.key;

  const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
  if (allowedKeys.includes(inputChar)) {
    return;
  }

  // Si los números están permitidos, dejamos pasar
  if (allowNumbers && /^[0-9]$/.test(inputChar)) {
    event.preventDefault();
  }

  // Bloquear números si 'allowNumbers' es false
  if (!allowNumbers && !/^[0-9]$/.test(inputChar)) {
    event.preventDefault();
  }
}

}
